<mat-dialog-content>
    <h3>{{message}}</h3>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center" class="mt-2 mb-1">
    <button mat-raised-button mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
    <button mat-raised-button (click)="onConfirmClick()" color="primary" tabindex="-1">{{okButtonText}}</button>
</mat-dialog-actions>